// Token utilities
export function getToken() {
  return localStorage.getItem('token')
}

export function setToken(token) {
  return localStorage.setItem('token', token)
}

export function removeToken() {
  return localStorage.removeItem('token')
}

// User info utilities
export function getUserInfo() {
  const userInfo = localStorage.getItem('userInfo')
  return userInfo ? JSON.parse(userInfo) : null
}

export function setUserInfo(userInfo) {
  return localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

export function removeUserInfo() {
  return localStorage.removeItem('userInfo')
}

// Check if user is logged in
export function isLoggedIn() {
  const token = getToken();
  console.log('Auth check - token exists:', !!token);
  return !!token;
}

// Clear all auth data (for logout)
export function clearAuth() {
  removeToken()
  removeUserInfo()
  try {
    localStorage.removeItem('deepark_wechat_bound')
    sessionStorage.removeItem('deepark_wx_oauth_code')
    sessionStorage.removeItem('deepark_wx_oauth_redirect_ts')
  } catch (e) {
    /* ignore */
  }
}

/** @deprecated alias — use clearAuth */
export function logout() {
  clearAuth()
}

// Add a function to help with debugging
export function clearAllStorage() {
  console.log('Clearing all authentication data');
  localStorage.clear();
  return true;
} 